import { DoBoxEntryKind, InboxEntry } from '@this+that/models';

import { useActiveInboxEntryById } from './useActiveInboxEntryById';
import { DOBOX_ACCENT_COLOR } from '../../pages/private/DoBox/components/DoBoxTaskGroupSelector/constants/constants';
import { useDetailedInboxEntry } from '../../services/inboxEntries.service';
import { useInboxEntriesStore } from '../../store/Inbox/InboxEntries';
import {
  PendingActionType,
  usePendingActionsStore,
} from '../../store/PendingActions';

export enum LinkedDoBoxEntryStatus {
  LOADING = 'loading',
  READY = 'ready',
  EMPTY = 'empty',
}

export interface LinkedDoBoxEntryItem {
  id: string;
  status: LinkedDoBoxEntryStatus;
  entry?: InboxEntry;
  taskGroupName?: string;
  taskGroupColor?: string;
  isResolved?: boolean;
  isPending?: boolean;
  isApproval?: boolean;
  isSuggestion?: boolean;
}

export const useLinkedDoBoxEntry = (id: string): LinkedDoBoxEntryItem => {
  const storeEntry = useActiveInboxEntryById(id);
  const { taskGroups } = useInboxEntriesStore((s) => s.taskManager.taskGroups);
  const pending = usePendingActionsStore((s) => s.getPendingActionForEntry(id));
  const { entry: fetchedEntry, loading } = useDetailedInboxEntry(id, {
    skip: !id || Boolean(storeEntry),
  });

  const entry = storeEntry ?? fetchedEntry;

  if (!entry) {
    return {
      id,
      status: loading
        ? LinkedDoBoxEntryStatus.LOADING
        : LinkedDoBoxEntryStatus.EMPTY,
    };
  }

  const taskGroup = taskGroups.find((group) => group?.id === entry.taskGroupId);

  return {
    id,
    status: LinkedDoBoxEntryStatus.READY,
    entry,
    taskGroupName: taskGroup?.title,
    taskGroupColor: taskGroup?.hexColor ?? DOBOX_ACCENT_COLOR,
    isResolved: pending
      ? pending.type === PendingActionType.RESOLVE
      : entry.resolvedAt != null,
    isPending: Boolean(pending),
    isApproval: entry.entryKind === DoBoxEntryKind.APPROVAL,
    isSuggestion: Boolean(entry.isSuggestion),
  };
};
